import PropTypes from "prop-types";

import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

import {
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Checkbox,
  Divider,
  Drawer,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useMaterialUIController } from "context";
import { setAction } from "context";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import getText from "Translator";
import { setLoading } from "context";
import { updateDateMode } from "controllers/UserController";
import { setDateMode } from "context";
import { setLang } from "context";
import { setTitle } from "context";
import { updateLang } from "controllers/UserController";
import { setHeader } from "context";
import { setLogout } from "context";

function Footer(props) {
  const { handleDrawerToggle } = props;
  const [value, setValue] = useState();
  const [open2, setOpen2] = useState(false);
  const [open, setOpen] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();

  const closeHandle = () => {
    setOpen(false);
    setAction(dispatch, "closefile");
  };
  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      style={{
        height: 45,
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#039dfc",
        zIndex: 999,
      }}
    >
      <BottomNavigation
        style={{ backgroundColor: "#039dfc" }}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        className="root"
      >
        {controller.userRole !== "filler" && (
          <BottomNavigationAction
            onClick={() => {
              window.location.replace("/main/complaints");
             // props.props.history.replace('/main/startpage/')
            }}
            icon={<HomeOutlinedIcon fontSize="medium" />}
          />
        )}
        {controller.header &&
          controller.userRole !== "filler" &&
          controller.header.includes("filelist") &&
          controller.header.includes("resultpagemenu") == false && (
            <BottomNavigationAction
              onClick={() => {
                setAction(dispatch, "filelist" + new Date());
              }}
              icon={<ListAltOutlinedIcon fontSize="medium" />}
            />
          )}

        {controller.authenticated &&
          controller.header &&
          controller.userRole !== "filler" &&
          controller.header.includes("resultpagemenu") && (
            <BottomNavigationAction
              onClick={() => {
                setAction(dispatch, "share" + new Date());
              }}
              icon={<ShareOutlinedIcon fontSize="medium" />}
            />
          )}
        {controller.header &&
          controller.header.includes("filelist") &&
          controller.userRole !== "filler" && (
            <BottomNavigationAction
              onClick={() => {
                setAction(dispatch, "fileattach" + new Date());
              }}
              icon={<AttachFileOutlinedIcon fontSize="medium" />}
            />
          )}
        {controller.authenticated &&
          controller.header &&
          controller.userRole !== "filler" &&
          controller.header.includes("favorite") && (
            <BottomNavigationAction
              onClick={() => {
                setAction(dispatch, "favorite" + new Date());
              }}
              icon={
                <FavoriteBorderOutlinedIcon
                  fontSize="medium"
                  style={{
                    color: controller.favorite == true ? "#fcdf03" : "#FFF",
                  }}
                />
              }
            />
          )}

        <BottomNavigationAction
          // onClick={handleDrawerToggle}
          onClick={() => {
            setOpen(true);
          }}
          icon={<WidgetsOutlinedIcon fontSize="medium" />}
        />

        {controller.header && controller.userRole !== "filler" &&  controller.header.includes("search") && (
          <BottomNavigationAction
            onClick={() => {
              setAction(dispatch, "search" + new Date());
            }}
            icon={<SearchOutlinedIcon fontSize="medium" />}
          />
        )}
      </BottomNavigation>
      <Drawer
        anchor="bottom"
        swipeAreaWidth={56}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
        open={open}
        onClose={closeHandle}
      >
        <div className="drawertitle">
          <IconButton
            style={{
              color: "#FFF",
              height: 35,
              width: 35,
              top: 5,
              position: "absolute",
              right: 5,
            }}
            aria-label="HighlightOffOutlinedIcon"
            onClick={() => {
              setOpen(false);
            }}
          >
            <HighlightOffOutlinedIcon />
          </IconButton>
        </div>
        <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
          <List>
            {controller.authenticated && (
              <>
                {/* <ListItem
                  style={{
                    height: 40,
                    cursor: "pointer",
                    //backgroundColor: open2 ? "RGBA(176, 176, 176, 0.7)" : "transparent",
                  }}
                  onClick={() => {
                    setOpen2(!open2);
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="inherit"
                        style={{
                          color: "#039dfc",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        {getText("setting", "fa")}
                      </Typography>
                    }
                  />
                  {open2 && (
                    <KeyboardArrowDownIcon style={{ color: "#fcaaa4" }} />
                  )}
                  {!open2 && (
                    <>
                      {controller.direction == "rtl" && (
                        <KeyboardArrowLeftIcon style={{ color: "#039dfc" }} />
                      )}
                      {controller.direction == "ltr" && (
                        <KeyboardArrowRightIcon style={{ color: "#039dfc" }} />
                      )}
                    </>
                  )}
                </ListItem> */}
                {open2 && (
                  <>
                    <Grid
                      container
                      style={{
                        height: 50,
                        paddingInlineStart: 20,
                        paddingTop: 5,
                        backgroundColor: "RGBA(245, 245, 245, 0.7)",
                      }}
                    >
                      <Grid item xs={4} sm={4} md={4}>
                        <ListItemText
                          primary={
                            <Typography
                              variant="inherit"
                              style={{
                                color: "#039dfc",
                                fontSize: 14,
                                fontWeight: "bold",
                              }}
                            >
                              {getText("datemode", "fa")}
                            </Typography>
                          }
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                controller.dateMode == "fa" ? true : false
                              }
                            />
                          }
                          label="شمسی"
                          onClick={async () => {
                            let newData = {
                              dateMode: "fa",
                            };

                            setLoading(dispatch, true);
                            let result = await updateDateMode(
                              newData,
                              controller
                            );
                            if (result.success) {
                              setDateMode(dispatch, "fa");
                              Swal.fire({
                                text: getText("alertsuccess", "fa"),
                                position: "bottom-end",
                                background: "#03fca1",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            } else {
                              Swal.fire({
                                text: getText("warningalert", "fa"),
                                position: "bottom-end",
                                background: "#f1b3af",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            }

                            setLoading(dispatch, false);
                            setOpen(false);
                          }}
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                controller.dateMode == "en" ? true : false
                              }
                            />
                          }
                          label="English"
                          onClick={async () => {
                            let newData = {
                              dateMode: "en",
                            };

                            setLoading(dispatch, true);
                            let result = await updateDateMode(
                              newData,
                              controller
                            );
                            if (result.success) {
                              setDateMode(dispatch, "en");
                              Swal.fire({
                                text: getText("alertsuccess", "fa"),
                                position: "bottom-end",
                                background: "#03fca1",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            } else {
                              Swal.fire({
                                text: getText("warningalert", "fa"),
                                position: "bottom-end",
                                background: "#f1b3af",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            }

                            setLoading(dispatch, false);
                            setOpen(false);
                          }}
                        />
                      </Grid>
                    </Grid>

                    {/* <Grid
                      container
                      style={{
                        height: 50,
                        paddingInlineStart: 20,
                        paddingTop: 5,
                        backgroundColor: "RGBA(245, 245, 245, 0.7)",
                      }}
                    >
                      <Grid item xs={4} sm={4} md={4}>
                        <ListItemText
                          primary={
                            <Typography
                              variant="inherit"
                              style={{
                                color: "#039dfc",
                                fontSize: 14,
                                fontWeight: "bold",
                              }}
                            >
                              {getText("changelang", "fa")}
                            </Typography>
                          }
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={"fa" == "fa" ? true : false}
                            />
                          }
                          label="فارسی"
                          onClick={() => {
                            let newData = {
                              lang: "fa",
                            };
                            updateLang(newData, controller);

                            setLang(dispatch, { lang: "fa", direction: "rtl" });
                            setTitle(dispatch, {
                              title: getText("setting", "fa"),
                              subtitle: "",
                            });

                            window.location.reload();
                          }}
                        />
                      </Grid>
                      <Grid item xs={4} sm={4} md={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={"fa" == "en" ? true : false}
                            />
                          }
                          label="English"
                          onClick={async () => {
                            let newData = {
                              lang: "en",
                            };
                            let result = await updateLang(newData, controller);
                            if (result.success) {
                              setLang(dispatch, {
                                lang: "en",
                                direction: "ltr",
                              });

                              setTitle(dispatch, {
                                title: getText("iclc", "fa"),
                                subTitle: "",
                              });
                              setHeader(dispatch, "");

                              Swal.fire({
                                text: getText("alertsuccess", "fa"),
                                position: "bottom-end",
                                background: "#03fca1",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                              window.location.reload();
                            } else {
                              Swal.fire({
                                text: getText("warningalert", "fa"),
                                position: "bottom-end",
                                background: "#f1b3af",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            }
                          }}
                        />
                      </Grid>
                    </Grid> */}
                  </>
                )}
                <Divider />
                {controller.userRole !== "filler" && (
                  <>
                    <ListItem
                      style={{
                        height: 50,

                        paddingInlineStart: 20,
                      }}
                      button
                      onClick={() => {
                        navigate("/profile");
                      }}
                    >
                      <ListItemText
                        primary={
                          <Typography
                            variant="inherit"
                            style={{
                              color: "#039dfc",
                              fontSize: 14,
                              fontWeight: "bold",
                            }}
                          >
                            {getText("profile", "fa")}
                          </Typography>
                        }
                      />
                    </ListItem>
                    <Divider />
                  </>
                )}
                {/* <ListItem
                  style={{
                    height: 50,

                    paddingInlineStart: 20,
                  }}
                  button
                  onClick={() => {
                    navigate("/cooperates");
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="inherit"
                        style={{
                          color: "#039dfc",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        {getText("cooperate", "fa")}
                      </Typography>
                    }
                  />
                </ListItem>

                <Divider /> */}
                <ListItem
                  style={{
                    height: 50,

                    paddingInlineStart: 20,
                  }}
                  button
                  onClick={() => {
                    setLogout(dispatch, controller);
                    navigate("/", { replace: true });
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="inherit"
                        style={{
                          color: "#039dfc",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        {getText("exit", "fa")}
                      </Typography>
                    }
                  />
                </ListItem>

                <Divider />
              </>
            )}
            {!controller.authenticated && (
              <>
                <ListItem
                  style={{
                    height: 50,
                    cursor: "pointer",
                    backgroundColor: open2
                      ? "RGBA(176, 176, 176, 0.7)"
                      : "transparent",
                  }}
                  onClick={() => {
                    navigate("/authentication/sign-in", { replace: true });
                  }}
                  button
                >
                  <ListItemText
                    primary={
                      <Typography
                        variant="inherit"
                        style={{
                          color: "#039dfc",
                          fontSize: 14,
                          fontWeight: "bold",
                        }}
                      >
                        {getText("login", "fa")}
                      </Typography>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            )}
          </List>
        </div>
      </Drawer>
    </MDBox>
  );
}

export default Footer;
